/**
 * Pure helpers for `CreateGroupDialog`, kept outside the component file
 * (react-refresh wants component-only modules) so they are unit-testable
 * without mounting MUI.
 */

/**
 * Routes a 409 conflict to the field it belongs to. Both backend messages
 * embed a user-supplied group name (`Group name "X" already exists` /
 * `Group "X" already has the same category rule` — see
 * GroupsService), so the routing must NOT keyword-match anything that can
 * appear inside the quoted name. The duplicate-categoryRule message is the
 * only one that ENDS with the "already has the same category rule" phrase
 * (the duplicate-name one always ends with `" already exists`), so anchor
 * on that suffix; everything else — duplicate name or unrecognized copy —
 * defaults to the name field.
 */
export function conflict409Field(message: string): 'category' | 'name' {
  return /already has the same category\s*rule\s*$/i.test(message)
    ? 'category'
    : 'name';
}

/**
 * Collision-proof select value/key for a category bucket — a plain
 * string-join could collide (e.g. `a b`+`c` vs `a`+`b c`).
 */
export const categoryKey = (
  category: string,
  subcategory: string | null
): string => JSON.stringify([category, subcategory ?? null]);
